import { homePhotoProps, HOME_HALF_SIZES } from "@/lib/homePhotoProps";
import { ArrowRight } from "lucide-react";
import ProjectImage from "@/components/ProjectImage";
import { SHOP_URL } from "@/data/siteNavigation";

import meodedDisplay from "@/assets/meoded-plaster-supplies-display.webp.asset.json";

const HomeShopMeoded = () => (
  <section className="bg-sand" aria-labelledby="shop-meoded-heading">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-16 md:py-20 grid gap-10 lg:grid-cols-2 lg:items-center">
      <div className="max-w-xl">
        <p className="text-[11px] uppercase tracking-[0.28em] text-clay mb-4">Materials</p>
        <h2 id="shop-meoded-heading" className="font-heading text-3xl md:text-4xl text-foreground leading-tight">
          Shop Meoded Paint &amp; Plaster
        </h2>
        <p className="mt-5 text-sm md:text-base text-muted-foreground leading-relaxed">
          Purchase limewash, decorative plaster, microcement, primers and finishing supplies from
          our Wayne, NJ studio.
        </p>
        <div className="mt-8">
          <a
            href={SHOP_URL}
            className="inline-flex min-h-[48px] items-center justify-center gap-2 bg-clay hover:bg-clay-dark text-primary-foreground px-8 py-4 text-[11px] font-semibold uppercase tracking-[0.16em] transition-colors"
          >
            Shop Materials
            <ArrowRight className="w-3.5 h-3.5" aria-hidden="true" />
          </a>
        </div>
      </div>
      <div className="aspect-[3/2] overflow-hidden bg-muted">
        <ProjectImage
          src={meodedDisplay.url} {...homePhotoProps(meodedDisplay.url, HOME_HALF_SIZES)}
          alt="Meoded plaster supplies: Palladino Venetian plaster, Intonaco, Lime Wash and Lime Wash Base Coat cans and pails with trowels and a limewash brush"
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  </section>
);

export default HomeShopMeoded;
